import Lottie from "lottie-react";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  ActionType,
  AppcuesConstant,
  FileNotation,
  StatusCode
} from "../../../assets/constants/constants";
import { analytics_category, analytics_event, analytics_label, appcues_event } from '../../../assets/constants/staticContentConstants';
import { AppContext } from "../../../context/AppProvider";
import useGaEventTracking from '../../../hooks/UseGaEventTracking';
import { postRecommendedContent } from "../../../services/ai";
import {
  getExerciseCourse,
  getLottieFileContent
} from "../../../services/user";
import DialogModal from "../DialogModal";
import { ScormExercisePoc } from "./ScormExercisePoc";
import { putAppCuesData } from "../../../lib/appcues";
type ExerciseContentProp = {
  programData: any;
  currentLessionDetail: any;
  programId?: string;
  programName?: string;
  courseId?: string;
  userId?: string;
  tags?:any;
  playVideo: (s: boolean) => void;
  updateCompaletedStatus: () => void;
  exerciseModule:any;
  completedCourses:[];
};
export const ExerciseContent: React.FC<ExerciseContentProp | any> = ({
  currentLessionDetail,
  programData,
  programId,
  programName,
  courseId,
  updateCompaletedStatus,
  userId,
  playVideo,
  exerciseModule,
  completedCourses
}) => {
  
  const { state, dispatch } = useContext(AppContext);

  const gaEventTracker = useGaEventTracking();
  const [showModal, setShowModal] = useState<boolean>(false);
  const navigate = useNavigate();
  const [exerciseLottieJson, setExerciseLottieJson] = useState<string>("");
  const [player, setPlayer] = useState<boolean>(true);
  const exerciseId =currentLessionDetail.tags.filter((item:string) => item.split(':')[0] === 'exercise')[0];
  useEffect(() => {
    currentLessionDetail?.supplementaryResources?.forEach((val: any) => {
      programData?.included?.find((ele: any) => {
        if (ele.id === val.id) {
          const file = ele.attributes.name;
          if (file.endsWith(FileNotation.finish) && ele?.attributes?.location) {
            getLottieFileContent(ele?.attributes?.location).then((res: any) => {
              if (res.status === StatusCode.SUCCESS)
                setExerciseLottieJson(res.data);
            });
          }
        }
      });
    });
  }, [currentLessionDetail]); 
  const getCourseStatus = () => {
    if(!completedCourses.includes(currentLessionDetail.id)){
      dispatch({type: ActionType.SET_LOADING, payload: true});
      getExerciseCourse(currentLessionDetail.id,exerciseModule).then((res: any) => {
        dispatch({type: ActionType.SET_LOADING, payload: false});
        if (res.status === StatusCode.SUCCESS) {
          const { isCourseCompleted } = res.data;
          // show complete button, show lottie image, api update isCourseCompleted=1;
          if (isCourseCompleted > 0) {

            const today = new Date();
             const items = {
                        value: null,
                        currency: null,
                        transaction_id: null,
                        items: [{}],
                        user_id:state.user?.userId,
                        program_name:currentLessionDetail.programName,
                        course_name:currentLessionDetail.name,
                        completion_date:today.toLocaleDateString(),
                        completion_status:"Yes"
                    };      
                  gaEventTracker(analytics_event.exerciseCompleted,analytics_category.buttonClickExerciseActivity,analytics_label.exerciseFinishedLable,items);
              setPlayer(false)
              setShowModal(true);
              updateCompaletedStatus(currentLessionDetail.id);
              putAppCuesData({
                      event_Name:appcues_event.lessonCompleted,
                      eventName:`${appcues_event.lessonCompleted}_${currentLessionDetail?.id}_${currentLessionDetail?.name}`,
                      userId: state.user?.email || "",
                      lesson_id: currentLessionDetail?.id,
                      lesson_name: currentLessionDetail?.name,
                      program_id:programData?.data?.id,
                      lesson_type:AppcuesConstant.exercise,
                      event_timestamp: new Date().toISOString(),
                    })
                postRecommendedContent({
                user_id: state.user?.userId,
                program_name: currentLessionDetail.programName.trim()
                })
          }else{
            setPlayer(false)
            playVideo(false);
          }
        } else { 
          setPlayer(false)
          playVideo(false);
        }
      });
    }else{
      setPlayer(false);
      playVideo(false);
    } 
  };
   
  const closeModel = () => {
    setShowModal(false);
    playVideo(false)
  };

  const viewRecommendedContent = async () => {
    navigate("/home/library");
    setShowModal(false);
  };

  return (
    <div className="flex flex-col">
      {showModal && (
        <DialogModal
          open={true}
          onClose={closeModel}
          title={currentLessionDetail.programName}
          body={<Lottie animationData={exerciseLottieJson} loop={true} className="lottie-card" />}
          onButtonClick={viewRecommendedContent}
        />
      )}
      { player && exerciseId && <ScormExercisePoc
        programData={programData}
        programId={programId}
        programName={programName}
        courseId={courseId}
        userId={userId}
        playVideo={getCourseStatus}
        updateCompaletedStatus={updateCompaletedStatus}
        exerciseId={exerciseId}
      />}
    </div>
  );
};
